module.exports = __webpack_public_path__ + "static/img/banner_02.3db615b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/join/banner_02.jpg
// module id = euzw
// module chunks = 0